import fetcher from "../../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import { FacilityReportResponseWrapper } from "./types";
import { downloadFacilityReport } from "../../../lib/utils";

const ERROR_MESSAGE = "Не удалось получить отчет по указаной квартире";

const useFacilityReport = (
  facilityId: number,
  facilityTitle: string = "квартира"
) => {
  async function fetchFacilityReport(url: string) {
    try {
      if (facilityId) {
        const data = fetcher.swr<FacilityReportResponseWrapper>(url);
        downloadFacilityReport(() => data, facilityTitle);
        return data;
      }
    } catch (error) {
      console.log(error, ERROR_MESSAGE);
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    `/facility/${facilityId}/report/pdf`,
    fetchFacilityReport
  );

  return {
    data,
    error,
    isMutating,
    trigger,
  };
};

export default useFacilityReport;
